
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFiveStarFnMixins from '~/mixins/eventTrackingFiveStarFnMixins.js';
import pageMeta from '~/mixins/pageMeta.js';

export default {
    name: "FiveStarProductsInsurerPageV2",
    components: { VueSlickCarousel },
    mixins: [pageMeta, eventTrackingMixins, eventTrackingFiveStarFnMixins],
    props: {
        insurer: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
      return {
        sideBySideActiveItemCode: '0',
        productSectionActiveItemCode: '0',
        carouselSettings: {
              "arrows": true,
              "dots": true,
              "focusOnSelect": true,
              "infinite": true,
              "speed": 500,
              "slidesToShow": 4,
              "slidesToScroll": 1,
              "touchThreshold": 5,
              "autoplay": true,
              "responsive": [
              {
                  "breakpoint": 1280,
                  "settings": {
                  "slidesToShow": 3,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "autoplay": true,
                  "arrows": true,
                  "dots": true
                  }
              },
              {
                  "breakpoint": 1024,
                  "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "autoplay": true,
                  "arrows": false,
                  "dots": true
                  }
              },
              {
                  "breakpoint": 760,
                  "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "centerMode": true,
                  'centerPadding': '30px',
                  "autoplay": false,
                  "arrows": false,
                  "dots": true
                  }
              },
              {
                  "breakpoint": 480,
                  "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "centerMode": true,
                  'centerPadding': '30px',
                  "autoplay": false,
                  "arrows": false,
                  "dots": true
                  }
              }
              ]
          }
      };
    },
    computed: {
      pageData() {
          return this.insurer;
      },
      subcategories() {
        return (this.data?.length > 1) ? this.data : null
      },
      insurerCode() {
        return this.$route?.params?.any.split('-')[1]
      }

    },

    mounted() {
      this.initSideBySideActiveItemCode()
      this.initProductSectionActiveItemCode()
    },

    methods: {
      iconCodeClassName(iconCode) {
        return `icon-${iconCode.toLowerCase()}`
      },
      initSideBySideActiveItemCode() {
        if (this.insurer?.Content.find(obj => obj.__typename === 'ComponentFiveStarsSideBySideSwitch')) {
          this.setSideBySideActiveItemCode('1')
        } else {
          this.setSideBySideActiveItemCode('0')
        }
      },
      initProductSectionActiveItemCode() {
        const switchItem = this.insurer?.Content.find(obj => obj.__typename === 'ComponentFiveStarsProductSectionSwitch')

        if (switchItem) {
          console.debug('switchItem: ', switchItem)
          console.debug('switchItem.InsurerProductSectionSwitchItem[0].GroupCode: ', switchItem.InsurerProductSectionSwitchItem[0].GroupCode)
          if (!this.$route.params?.any2) {
            this.setProductSectionActiveItemCode(switchItem?.InsurerProductSectionSwitchItem[0]?.GroupCode)
          } else {
            this.setProductSectionActiveItemCode(this.$route.params?.any2)
          }
        }
      },
      setSideBySideActiveItemCode(code) {
        this.sideBySideActiveItemCode = code
      },
      setProductSectionActiveItemCode(code, gotoAnchor = false) {
        this.productSectionActiveItemCode = code

        if (gotoAnchor) {
          this.$router.push({path: this.localePath('/5star-products-2025/' + this.$route.params.any + '/' + code + '#award-products')})
        }
      },
      sectionStyle(layoutStyleData) {
          const style = []
          if (layoutStyleData?.LayoutStyle?.PaddingTopInPx >= 0 ) {
              style.push({'padding-top': `${layoutStyleData?.LayoutStyle?.PaddingTopInPx ? layoutStyleData?.LayoutStyle?.PaddingTopInPx + 'px' : undefined }`})
          }
          if (layoutStyleData?.LayoutStyle?.PaddingBottomInPx >= 0 ) {
              style.push({'padding-bottom': `${layoutStyleData?.LayoutStyle?.PaddingBottomInPx ? layoutStyleData?.LayoutStyle?.PaddingBottomInPx + 'px' : undefined }`})
          }
          if (layoutStyleData?.LayoutStyle?.BackgroundColorHex) {
              style.push({'background': `#${layoutStyleData?.LayoutStyle?.BackgroundColorHex}`})
          }
          return style
      },

    },

    watch: {
      subcategories(newValue, oldValue) {
          if (newValue !== oldValue) {
            console.debug('subcategories in subcat option changed...')
          }
        }
    },

}
